/**
 * Application entry point
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { configureAmplify } from './auth'
import './styles/globals.css'

// Configure AWS Amplify for Cognito auth
configureAmplify()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
